import React from 'react';
import Select from 'react-select';
import axios from 'axios';
import constants from '../util/constants';
import AllocationWeekTotals from './AllocationWeekTotals';
import AllocationDetails from './AllocationDetails';
import AllocationOnlyOrders from './AllocationOnlyOrders';
import NPPanel from '../NPPanel';
import './style.scss';
import LoadingSpinner from '../LoadingSpinner';
import { Col, Row, Form, FormGroup, Button, InputGroup, Dropdown, MenuItem } from 'react-bootstrap';
import apiHelper from '../util/api.helper.js';
import { hasGrant } from '../util/grantHelper.js';
import * as Grants from '../util/grants.js';
import downloadFile from 'react-file-download';
import * as Convert from '../util/unitConversion';
import AllocationGroups from './AllocationGroups';
import EditedAllocationWarnings from './EditedAllocationWarnings';
import { formatMarketAreaDesc } from './AllocationHelper/index.js';

export function getCapacityWarningText(warning) {
    if (!warning.capacityWarning) return null;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const capacityType = warning.capacityWarning.isActualCapacity ? 'Actual' : 'Budget';
    const allocated = warning.capacityWarning.allocated?.toString().replace('.', ',');
    const actualCapacity = warning.capacityWarning.limit?.toString().replace('.', ',');
    return `${warning.pm} in ${months[warning.month - 1]}: Allocated: ${allocated} > ${capacityType} capacity: ${actualCapacity}`;
}

export function getBudgetWarningText(warning, areaSalesDirectors) {
    if (!warning.budgetAllocationWarning) return null;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const allocated = warning.budgetAllocationWarning.allocated?.toString().replace('.', ',');
    const budgetAllocated = warning.budgetAllocationWarning.limit?.toString().replace('.', ',');
    const asdDesc = areaSalesDirectors?.find(x => x.MARKET_AREA_CODE === warning.areaSalesDirector)?.MARKET_DESCRIPTION;
    return `${formatMarketAreaDesc(warning.areaSalesDirector, asdDesc)}, ${warning.customer}, ${warning.pm} in ${months[warning.month - 1]}: Allocated: ${allocated} > Budget: ${budgetAllocated}`;
}

const { API_BASE_URL, PAPERLINE_BASE_URL } = constants;

class CustomerProfile extends React.Component {
    constructor(props) {
        super(props);

        this.refresh = this.refresh.bind(this);

        this.state = {
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            data: {
                TotalsView: {},
                TotalsWeekView: {},
                AllocationLeaves: [],
                DetailsView: [],
                DetailsWeekView: [],
                OnlyOrders: []
            },
            legalEntity: '',
            changedParams: false,
            userType: '',
            success: true,
            errorMessage: '',
            showError: false,
            selectedValue: '',
            isLoading: false,
            availableYears: [],
            selectedYear: {},
            searchedYear: {},
            searchObject: {},
            availableFilters: {},
            viewModeBoxes: [],
            viewModes: [],
            viewModesSortOrder: [{ label: 'A - Z', value: 0 }, { label: 'Z - A', value: 1 }, { label: 'Diff ascending', value: 2 }, { label: 'Diff descending', value: 3 }],
            selectedViewModesSortOrder: { label: 'A - Z', value: 0 },
            timeEntries: [
                { label: 'Q1', value: 13 }, { label: 'Q2', value: 14 }, { label: 'Q3', value: 15 }, { label: 'Q4', value: 16 },
                { label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'Mars', value: 3 }, { label: 'Apri', value: 4 },
                { label: 'May', value: 5 }, { label: 'June', value: 6 }, { label: 'July', value: 7 }, { label: 'August', value: 8 },
                { label: 'September', value: 9 }, { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }
            ],
            includeWOReleased: {},
            includeWOReleasedOptions: [
                { label: 'Include WO Released', value: 1 },
                { label: 'Exclude WO Released', value: 0 }
            ],
            selectedTimeEntries: [],
            selectedMachine: [],
            selectedAreaSalesDirectors: [],
            selectedAgents: [],
            selectedGroups: [],
            editedAllocations: [], // [{allocationId, month, allocated, originalAllocated, pm}]
            warningAllocations: [], // [{allocationId, month, allocated, originalAllocated, pm, warningBooked, warningActualCapacity, warningIsActualCapacity}]
            verifyingAllocationCount: 0,
            editMode: false,
            dropdownStyleSmall: {
                valueContainer: (provided) => ({
                    ...provided,
                    minWidth: '55px'
                }),
            },
            dropdownStyleLarge: {
                valueContainer: (provided) => ({
                    ...provided,
                    minWidth: '160px'
                }),
            },
            dropdownStyleMedium: {
                valueContainer: (provided) => ({
                    ...provided,
                    minWidth: '100px'
                })
            },
        };
        this.prependToList = this.prependToList.bind(this);
        this.clearAll = this.clearAll.bind(this);
        this.exportToExcel = this.exportToExcel.bind(this);
        this.transformList = this.transformList.bind(this);
        this.openOrderReport = this.openOrderReport.bind(this);
        this.openLinkNewTab = this.openLinkNewTab.bind(this);
        this.handleEditedAllocationsChange = this.handleEditedAllocationsChange.bind(this);
        this.handleWarningAllocationsChange = this.handleWarningAllocationsChange.bind(this);
        this.handleSelectedGroupsChange = this.handleSelectedGroupsChange.bind(this);
        this.handleEditModeChange = this.handleEditModeChange.bind(this);
        this.setVerifyingAllocationCount = this.setVerifyingAllocationCount.bind(this);
        this.initialize();
    }

    initialize() {
        // Hämta filtervärden här med eget anrop, gärna eget objekt också, kan även innehålla alla allokerade år med så lyfts de ut från AllocationMainWrapper och blir enbart startvärden
        axios.get(API_BASE_URL+'Allocation/GetAllocationFilters',{headers: this.state.header})
        .then(response => {
            let data = response.data;

            // Append customerFilter to too be availableFilters object
            apiHelper.getAllocationCustomerFilter(this.state.header)
                .then(customerList => {
                    data.Customers = customerList;

                    this.setState({ showError: false, success: true, availableFilters: data, userType: window.sessionStorage.getItem('UserType') });
                    let viewModesList = [];
                    if (data.LegalEntity === 'NP') {
                        viewModesList = [{ label: 'Customer', value: 1 }, { label: 'PM', value: 2 }, { label: 'Grade', value: 3 }, { label: 'Country', value: 4 }, /*{ label: 'End Use', value: 5 }, { label: 'Grammage', value: 6 },*/ { label: 'Prod. Type', value: 7 }, { label: 'Agent', value: 8 }];
                        this.setState({
                            includeWOReleased: this.state.includeWOReleasedOptions[1] // Exclude
                        })
                    }
                    else {
                        viewModesList = [{ label: 'Customer', value: 1 }, { label: 'PM', value: 2 }, { label: 'Country', value: 4 }, { label: 'Agent', value: 8 }];
                        this.setState({
                            includeWOReleased: this.state.includeWOReleasedOptions[0] // Include
                        })
                    }
                    if (data.UserType !== 1) {
                        viewModesList.pop();
                    }
                    this.setState({ viewModes: viewModesList });
                    this.search(true);
                })
        });
        // Set selected filters to match the topfilters
        apiHelper.getSelectedFilters(this.state.header)
            .then(result => {
                if (result) {
                    if (result.MarketAreaCodeFilter){
                        this.setState({
                            selectedAreaSalesDirectors: [{
                                label: `${result.MarketAreaCodeFilter.Value} - ${result.MarketAreaCodeFilter.Label}`,
                                value: result.MarketAreaCodeFilter.Value
                            }]
                        });
                    }
                    if (result.AgentFilter){
                        this.setState({
                            selectedAgents: [{
                                label: `${result.AgentFilter}`,
                                value: result.AgentFilter
                            }]
                        });
                    }
                    if (result.CustomerFilter){
                        this.setState({
                            selectedCustomers: [{
                                label: result.CustomerFilter.Label,
                                value: result.CustomerFilter.Value
                            }]
                        });
                    }
                }
            });
    }

    refresh() {
        this.setState({});
    }

    applySearchFilters(searchFilters) {
        const newState = {};

        // Set Year
        if (searchFilters.Year) {
            const year = parseInt(searchFilters.Year, 10);
            newState.selectedYear = { label: year, value: year };
        }

        // Set Machines
        if (searchFilters.Machines && searchFilters.Machines.length > 0) {
            newState.selectedMachine = searchFilters.Machines.map(m => ({ label: m, value: m }));
        }

        // Set Countries
        if (searchFilters.Countries && searchFilters.Countries.length > 0 && this.state.availableFilters.Countries) {
            const countryList = this.state.availableFilters.Countries
                .filter(countryStr => {
                    const code = countryStr.split(' - ')[1];
                    return searchFilters.Countries.includes(code);
                })
                .map(c => ({ label: c, value: c.split(' - ')[1] }));
            newState.selectedCountries = countryList;
        }

        // Set Grades
        if (searchFilters.Grades && searchFilters.Grades.length > 0) {
            newState.selectedGrades = searchFilters.Grades.map(g => ({ label: g, value: g }));
        }

        // Set Area Sales Directors
        if (searchFilters.AreaSalesDirectors && searchFilters.AreaSalesDirectors.length > 0 && this.state.availableFilters.AreaSalesDirectors) {
            const asdList = this.state.availableFilters.AreaSalesDirectors
                .filter(x => searchFilters.AreaSalesDirectors.includes(x.MARKET_AREA_CODE))
                .map(x => ({ label: formatMarketAreaDesc(x.MARKET_AREA_CODE, x.MARKET_DESCRIPTION), value: x.MARKET_AREA_CODE }));
            newState.selectedAreaSalesDirectors = asdList;
        }

        // Set Agents
        if (searchFilters.Agents && searchFilters.Agents.length > 0 && this.state.availableFilters.Agents) {
            const agentList = this.state.availableFilters.Agents
                .filter(x => searchFilters.Agents.includes(x.CLIENT_CODE_REGIONAL))
                .map(x => ({ label: `${x.CLIENT_CODE_REGIONAL} - ${x.SHORT_NAME}`, value: x.CLIENT_CODE_REGIONAL }));
            newState.selectedAgents = agentList;
        }

        // Set Customer IDs
        if (searchFilters.CustomerIds && searchFilters.CustomerIds.length > 0 && this.state.availableFilters.Customers) {
            const customerList = this.state.availableFilters.Customers
                .filter(x => searchFilters.CustomerIds.includes(String(x.value)));
            newState.selectedCustomers = customerList;
        }

        // Set Prod Type
        if (searchFilters.ProdType !== null && searchFilters.ProdType !== undefined) {
            newState.selectedProdType = searchFilters.ProdType === '0' 
                ? { label: 'Roll', value: '0' } 
                : searchFilters.ProdType === '1' 
                    ? { label: 'Sheet', value: '1' } 
                    : null;
        }

        // Set Include WO Released
        if (searchFilters.IncludeWOReleased !== null && searchFilters.IncludeWOReleased !== undefined) {
            const includeWOOption = this.state.includeWOReleasedOptions.find(x => x.value === searchFilters.IncludeWOReleased);
            if (includeWOOption) {
                newState.includeWOReleased = includeWOOption;
            }
        }

        // Update state with all collected settings
        this.setState(newState);
    }

    search(initialSearch) {
        let searchObject = {};
        let calculatedTimeEntries = [];
        this.setState({ editedAllocations: [], warningAllocations: []});
        this.state.selectedTimeEntries.forEach(e => {
            switch (e.value) {
                case 13:
                    calculatedTimeEntries.push(1, 2, 3);
                    break;
                case 14:
                    calculatedTimeEntries.push(4, 5, 6);
                    break;
                case 15:
                    calculatedTimeEntries.push(7, 8, 9);
                    break;
                case 16:
                    calculatedTimeEntries.push(10, 11, 12);
                    break;
                default:
                    calculatedTimeEntries.push(e.value);
                    break;
            }
        });

        searchObject.SearchFilters = {
            Year: this.state.selectedYear.value,
            TimeEntries: calculatedTimeEntries,
            Machines: this.state.selectedMachine.map(x => x.value),
            Grades: this.state.selectedGrades ? this.state.selectedGrades.map(x => x.value) : [],
            Countries: this.state.selectedCountries ? this.state.selectedCountries.map(x => x.value) : [],
            // EndUse: this.state.selectedEndUse ? this.state.selectedEndUse.value : '',
            // Grammage: this.state.selectedGrammage ? this.state.selectedGrammage.value : '',
            ProdType: this.state.selectedProdType ? this.state.selectedProdType.value : '',
            CustomerIds: this.state.selectedCustomers ? this.state.selectedCustomers.map(x => x.value) : [],
            AreaSalesDirectors: this.state.selectedAreaSalesDirectors.map(x => x.value),
            Agents: this.state.selectedAgents.map(x => x.value),
            includeWOReleased: this.state.includeWOReleased ? this.state.includeWOReleased.value : null
        };

        searchObject.Groups = this.state.selectedGroups;

        searchObject.DetailGroupings = [];
        searchObject.InitialSearch = initialSearch;
        searchObject.SortOrder = this.state.selectedViewModesSortOrder ? this.state.selectedViewModesSortOrder.value : 0;
        this.state.viewModeBoxes.forEach(x => x && searchObject.DetailGroupings.push(x.value));

        this.setState({ isLoading: true });
        axios.post(API_BASE_URL + 'Allocation/GetAllocation', searchObject, { headers: this.state.header })
            .then(response => {
                let data = response.data;
                if (data.AllocationSearch) {
                    let dg = data.AllocationSearch.DetailGroupings;
                    if (initialSearch){
                        this.applySearchFilters(data.AllocationSearch.SearchFilters);
                        this.handleSelectedGroupsChange(data.Groups);
                    }
                    let viewMode1 = dg.length > 0 && this.state.viewModes.find(x => x.value === dg[0]);
                    let viewMode2 = dg.length > 1 && this.state.viewModes.find(x => x.value === dg[1]);
                    let viewMode3 = dg.length > 2 && this.state.viewModes.find(x => x.value === dg[2]);
                    let viewMode4 = dg.length > 3 && this.state.viewModes.find(x => x.value === dg[3]);
                    let viewModes = [viewMode1, viewMode2, viewMode3, viewMode4];
                    this.setState({
                        viewModeBoxes: viewModes
                    })
                }
                this.setState({ isLoading: false, showError: false, success: true, data: data, changedParams: false, legalEntity: data.LegalEntity, availableYears: data.AvailableYears, searchedYear: this.state.selectedYear, searchObject: searchObject });
            })
            .catch(error => {
                let data = error?.response?.data;
                this.setState({ isLoading: false, showError: true, success: false, errorMessage: data?.Message || error });
            });
    }

    handleEditedAllocationsChange(newEditedAllocations) {
        //Group all new allocations (Negative allocationId) by allocationId
        const newAllocationsById = {};
        newEditedAllocations.forEach(x => {
            if (x.allocationId < 0) {
                if (!newAllocationsById[x.allocationId]) {
                    newAllocationsById[x.allocationId] = [];
                }
                newAllocationsById[x.allocationId].push(x);
            }
        });

        //Convert new allocations to follow leaf format
        const newDataAllocations = Object.values(newAllocationsById).map(monthEntries => {
            const first = monthEntries[0];
            return {
                Agent: first.agent,
                AllocationId: first.allocationId,
                AreaSalesDirector: first.areaSalesDirector,
                Country: first.country,
                Customer: first.customer,
                Grade: first.grade,
                Months: monthEntries.map(m => ({
                    Month: m.month,
                    Allocation: m.allocated,
                    BudgetAllocation: 0,
                    OrderedWeeks: [],
                    PreliminaryWeeks: [],
                    Comments: [],
                })),
                NoAllocationMatch: null,
                PM: first.pm,
                YearComments: [],
            }
        });
        let newAllocationLeaves = [...(this.state.data.AllocationLeaves || [])];
        newDataAllocations.forEach(newAlloc => {
            const index = newAllocationLeaves.findIndex(existingAlloc => existingAlloc.AllocationId === newAlloc.AllocationId);
            if (index !== -1){
                newAllocationLeaves[index] = newAlloc;
            }
            else {
                newAllocationLeaves.push(newAlloc);
            }
        });
        this.setState(prevState => ({ data: {...prevState.data, AllocationLeaves: newAllocationLeaves}, editedAllocations: newEditedAllocations }));
    }

    setVerifyingAllocationCount(isFetching) {
        this.setState(prevState => ({
            verifyingAllocationCount: prevState.verifyingAllocationCount + (isFetching ? 1 : -1)
        }));
    }

    handleWarningAllocationsChange(newWarningAllocations){
        this.setState({ warningAllocations: newWarningAllocations });
    }

    handleEditModeChange(editMode) {
        this.setState({ editMode });
    }

    handleSelectedGroupsChange(newSelectedGroups){
        this.setState({ selectedGroups: newSelectedGroups });

        axios.post(
            `${API_BASE_URL}Allocation/SetAllocationGroupSettings`,
            newSelectedGroups,
            { headers: this.state.header }
        ).catch(err => {
            console.error('Failed to save group settings', err);
        });
    }

    openOrderReport() {
        if (this.state.legalEntity === 'NP') {
            // Greaseproof user
            window.open('https://app.powerbi.com/reportEmbed?reportId=7bf2037a-f1cd-4fe6-a810-ed5483e185ab&appId=a79356e0-f10b-49bc-b4be-908802bc6fa2&autoAuth=true&ctid=bbf3234a-261f-4e77-8683-21b57e014af4', '_blank');
        }
        if (this.state.legalEntity === 'NPBA') {
            // Kraft user
            window.open('https://app.powerbi.com/reportEmbed?reportId=f63bfabb-3050-468b-8b54-06c4176ee8a5&autoAuth=true&ctid=bbf3234a-261f-4e77-8683-21b57e014af4', '_blank');
        }
    }

    openLinkNewTab(url){
        window.open(url, '_blank');
    }

    prependToList(values, type) {
        let list = [];
        if(type == 'Country')
            list = values ? values.map((y) => ({ label: y, value: y.split(' - ')[1] })) : [];
        else
            list = values ? values.map((y) => ({ label: y, value: y })) : [];

        let item = { label: 'Select ' + type, value: '' };

        list = [item, ...list];
        return list;
    }

    clearAll() {
        this.state.viewModeBoxes.forEach((slask, index, array) => { array[index] = null });
        this.setState({
            data: {
                TotalsView: { Rows: [], Comments: [] },
                DetailsView: []
            },
            success: true,
            showError: false,
            selectedValue: '',
            isLoading: false,
            selectedMachine: [],
            selectedGrades: null,
            selectedCountries: null,
            // selectedEndUse: null,
            // selectedGrammage: null,
            selectedProdType: null,
            selectedCustomers: null,
            selectedTimeEntries: [],
            selectedAreaSalesDirectors: [],
            selectedAgents: [],
            includeWOReleased: null,
            changedParams: false
        }, () => {
            this.search();
        })
    }

    getAllocationSearch() {
        let years = this.state.availableYears ? this.state.availableYears.map((y) => ({ label: y, value: y })) : [];
        //let years = this.prependToList(this.state.availableFilters.Year, "year");
        let greaseProofUser = this.state.legalEntity === 'NP';
        let machineFilters = this.prependToList(this.state.availableFilters.Machines, 'Machine');
        // let grammageFilters = this.prependToList(this.state.availableFilters.Grammages, 'Grammage');
        let countryFilters = this.prependToList(this.state.availableFilters.Countries, 'Country');
        let gradeFilters = this.prependToList(this.state.availableFilters.Grades, 'Grade');
        // let endUseFilters = this.prependToList(this.state.availableFilters.EndUses, 'End Use');
        let customerFilter = this.state.availableFilters.Customers; // Customers is already returned as a valid list 
        let areaSalesDirectorFilters = this.state.availableFilters.AreaSalesDirectors ? 
            this.state.availableFilters.AreaSalesDirectors.map((x) => ({ label: formatMarketAreaDesc(x.MARKET_AREA_CODE, x.MARKET_DESCRIPTION), value: x.MARKET_AREA_CODE})): [];
        let agentsFilters = this.state.availableFilters.Agents ?
            this.state.availableFilters.Agents.map((x) => ({ label: `${x.CLIENT_CODE_REGIONAL} - ${x.SHORT_NAME}`, value: x.CLIENT_CODE_REGIONAL})): [];

        let changed = {
            backgroundColor: this.state.changedParams ? 'pink' : '#00529c',
            border: this.state.changedParams ? '2px solid red' : ''
        };
        let changedText = {
            marginLeft: '5px'
        };
        const paperLinePms = this.state.legalEntity === 'NP' ?
            [{label: 'PM01', value: 'GPM1'}, {label: 'PM02', value: 'SPM2'}, {label: 'PM03', value: 'SPM3'}, {label: 'PM04', value: 'GPM4'}] :
                this.state.legalEntity === 'NPBA' ?
                    [{label: 'PM1A', value: 'APM1'}, {label: 'PM4B', value: 'BPM4'}, {label: 'PM5B', value: 'BPM5'}, {label: 'PM6A', value: 'APM6'}] :
                    [];

        return (
            <div>
                <Form inline className="searchForm" autoComplete="off" onSubmit={(evt) => { evt.preventDefault(); this.search() }}>
                    <Row>
                        <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "65px" }}>Year</InputGroup.Addon>
                                    <Select searchable={true}
                                        styles={this.state.dropdownStyleSmall}
                                        isClearable={false}
                                        options={years}
                                        menuContainerStyle={{ zIndex: 5 }}
                                        value={this.state.selectedYear}
                                        onChange={evt => {
                                            this.state.selectedYear = evt;
                                            this.state.changedParams = true;
                                            this.setState({});
                                        }}
                                    />
                                </InputGroup>
                            </FormGroup>
                        </Col>


                        <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "65px" }}>Month</InputGroup.Addon>
                                    <Select
                                        styles={this.state.dropdownStyleSmall}
                                        isMulti
                                        options={this.state.timeEntries}
                                        isClearable={true}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        defaultValue={[...this.state.selectedTimeEntries]}
                                        onChange={evt => {
                                            this.state.selectedTimeEntries = [...evt];
                                        }}
                                    />
                                </InputGroup>
                            </FormGroup>
                        </Col>

                        <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "65px" }}>Machine</InputGroup.Addon>
                                    <Select searchable={true}
                                        isMulti
                                        styles={this.state.dropdownStyleSmall}
                                        isClearable={true}
                                        options={machineFilters}
                                        menuContainerStyle={{ zIndex: 5 }}
                                        defaultValue={[...this.state.selectedMachine]}
                                        onChange={evt => {
                                            this.state.selectedMachine = [...evt];
                                            this.state.changedParams = true;
                                            this.setState({});
                                        }} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "65px" }}>Country</InputGroup.Addon>
                                    <Select searchable={true}
                                        isMulti
                                        styles={this.state.dropdownStyleSmall}
                                        options={countryFilters}
                                        isClearable={true}
                                        menuContainerStyle={{ zIndex: 5 }}
                                        value={this.state.selectedCountries}
                                        onChange={evt => {
                                            this.state.selectedCountries = [...evt];
                                            this.state.changedParams = true;
                                            this.setState({});
                                        }} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        {this.state.userType === '1' && <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "65px" }}>Market Area</InputGroup.Addon>
                                    <Select searchable={true}
                                        isMulti
                                        styles={this.state.dropdownStyleSmall}
                                        options={areaSalesDirectorFilters}
                                        isClearable={true}
                                        menuContainerStyle={{ zIndex: 5 }}
                                        value={this.state.selectedAreaSalesDirectors}
                                        onChange={evt => {
                                            this.state.selectedAreaSalesDirectors = [...evt];
                                            this.state.changedParams = true;
                                            this.setState({});
                                        }} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        }
                        {this.state.userType !== '3' && //Display agent filter for all users except customers
                            <Col sm={12} className="smaller-inputs filterGroup">
                                <FormGroup className="select">
                                    <InputGroup>
                                        <InputGroup.Addon style={{ width: "65px" }}>Agent</InputGroup.Addon>
                                        <Select searchable={true}
                                            isMulti
                                            styles={this.state.dropdownStyleSmall}
                                            options={agentsFilters}
                                            isClearable={true}
                                            menuContainerStyle={{ zIndex: 5 }}
                                            value={this.state.selectedAgents}
                                            onChange={evt => {
                                                this.state.selectedAgents = [...evt];
                                                this.state.changedParams = true;
                                                this.setState({});
                                            }} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        }

                        {greaseProofUser &&
                            <Col sm={12} className="smaller-inputs filterGroup">
                                <FormGroup className="select"  >
                                    <InputGroup>
                                        <InputGroup.Addon style={{ width: "65px" }}>Grade</InputGroup.Addon>
                                        <Select searchable={true}
                                            isMulti
                                            styles={this.state.dropdownStyleSmall}
                                            options={gradeFilters}
                                            isClearable={true}
                                            menuContainerStyle={{ zIndex: 5 }}
                                            value={this.state.selectedGrades}
                                            onChange={evt => {
                                                this.state.selectedGrades = [...evt];
                                                this.state.changedParams = true;
                                                this.setState({});
                                            }} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        }
                        {greaseProofUser &&
                            <Col sm={12} className="smaller-inputs filterGroup">
                                <FormGroup className="select">
                                    <InputGroup>
                                        <InputGroup.Addon style={{ width: "80px" }}>Prod. Type</InputGroup.Addon>
                                        <Select name="Prod. Type" searchable={true}
                                            styles={this.state.dropdownStyleSmall}
                                            isClearable={true}
                                            options={[{ label: 'Roll', value: '0' }, { label: 'Sheet', value: '1' }]}
                                            value={this.state.selectedProdType}
                                            onChange={evt => {
                                                this.state.selectedProdType = evt;
                                                this.state.changedParams = true;
                                                this.setState({});
                                            }}
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        }

                        <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <InputGroup.Addon style={{ width: "80px" }}>Customer</InputGroup.Addon>
                                    <Select name="Customer" searchable={true}
                                        isMulti
                                        styles={this.state.dropdownStyleSmall}
                                        isClearable={true}
                                        options={customerFilter}
                                        value={this.state.selectedCustomers}
                                        onChange={evt => {
                                            this.state.selectedCustomers = [...evt];
                                            this.state.changedParams = true;
                                            this.setState({});
                                        }}
                                    />
                                </InputGroup>
                            </FormGroup>
                        </Col>

                        <Col sm={12} className="smaller-inputs filterGroup">
                            <FormGroup className="select">
                                <InputGroup>
                                    <Select name="Customer" searchable={true}
                                        styles={this.state.dropdownStyleLarge}
                                        isClearable={false}
                                        options={this.state.includeWOReleasedOptions}
                                        value={this.state.includeWOReleased}
                                        onChange={evt => {
                                            this.state.includeWOReleased = evt;
                                            this.state.changedParams = true;
                                            this.setState({});
                                        }}
                                    />
                                </InputGroup>
                            </FormGroup>
                        </Col>

                        <Col sm={12}>
                            <FormGroup>
                                <Button type="submit" bsStyle="primary" style={changed}>
                                    Search
                            </Button>
                                {this.state.changedParams && <span style={changedText}>Filters changed, search again</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
                <Row>
                    <Col sm={12} className='text-right'>
                        <FormGroup>
                            {hasGrant(Grants.TYPES.Admin_ViewCapacityAllocation) && <Button bsStyle="primary" bsSize="small"
                                className="pull-right"
                                onClick={this.openOrderReport}
                                style={{marginRight: '10px'}}
                            >
                                Order report
                            </Button>}
                            {hasGrant(Grants.TYPES.Admin_ViewCapacityAllocation) && this.state.legalEntity &&
                                <Dropdown id="paperline-cascader" className="pull-right" style={{ marginRight: '10px', display: 'inline-block' }}>
                                    <Dropdown.Toggle bsStyle="primary" bsSize="small">
                                        Paperline
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <MenuItem onClick={() => this.openLinkNewTab(`${PAPERLINE_BASE_URL}#/capacity-planning`)}>Capacity</MenuItem>
                                        <Dropdown drop="right" id="allocation-submenu">
                                            <Dropdown.Toggle style={{ width: '100%', paddingLeft: '20px', background: 'none', border: 'none', color: '#7b8a8b' }}>
                                                Allocation
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {paperLinePms.map(pm =>
                                                <MenuItem key={pm.label} onClick={() => this.openLinkNewTab(`${PAPERLINE_BASE_URL}#/run-order-overview?favoriteCode=orderrow_detail_${pm.value}`)}>{pm.label}</MenuItem>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <Dropdown drop="right" id="blockplan-submenu">
                                            <Dropdown.Toggle style={{ width: '100%', paddingLeft: '20px', background: 'none', border: 'none', color: '#7b8a8b' }}>
                                                Blockplan
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {paperLinePms.map(pm =>
                                                <MenuItem key={pm.label} onClick={() => this.openLinkNewTab(`${PAPERLINE_BASE_URL}#/run-order-overview?favoriteCode=block_overview_${pm.value}`)}>{pm.label}</MenuItem>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <Dropdown drop="right" id="weekly-submenu">
                                            <Dropdown.Toggle style={{ width: '100%', paddingLeft: '20px', background: 'none', border: 'none', color: '#7b8a8b' }}>
                                                Weekly
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {paperLinePms.map(pm =>
                                                <MenuItem key={pm.label} onClick={() => this.openLinkNewTab(`${PAPERLINE_BASE_URL}#/run-order-overview?favoriteCode=weekly_overview_${pm.value}`)}>{pm.label}</MenuItem>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                            {/*
                            {hasGrant(Grants.TYPES.Admin_ViewCapacityAllocation) && <Button bsStyle="primary" bsSize="small"
                                className="pull-right"
                                onClick={this.openOrderOverview}
                                style={{marginRight: '10px'}}
                            >
                                PaperLine
                            </Button>}
                             */}
                            <Button bsStyle="primary" bsSize="small"
                            className="pull-right"
                            onClick={this.clearAll}
                            style={{marginRight: '10px'}}
                            >
                                Reset
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        );
    }

    exportToExcel() {
        const header = this.state.header;
        let data = this.transformWeekList(this.state.data.DetailsWeekView);
        axios.post(API_BASE_URL + 'Files/Export2Excel', data, {headers: header, responseType: "blob"})
            .then((result) => {
                downloadFile(result.data, "AllocationDetails.xlsx")
            })
    }

    transformList(detailsData) {
        var transformed = [];
        let chosenYear = this.state.selectedYear.value;

        function transformRow(row, year) {
            return {Header: row.ViewModes, Year: year, RowType: row.RowType, Jan: row.GuiM1_UC, Feb: row.GuiM2_UC, Mar: row.GuiM3_UC, Apr: row.GuiM4_UC, May: row.GuiM5_UC, Jun: row.GuiM6_UC, Jul: row.GuiM7_UC, Aug: row.GuiM8_UC, Sep: row.GuiM9_UC, Oct: row.GuiM10_UC, Nov: row.GuiM11_UC, Dec: row.GuiM12_UC, Total: row.GuiTotal_UC}
        }
        detailsData.forEach((detailsRow) => {
            detailsRow.Rows.forEach((row) => {
                transformed.push(transformRow(row, chosenYear))
            })
        })

        return transformed;
    }

    transformWeekList(detailsWeekData) {
        let chosenYear = this.state.selectedYear.value;

        return detailsWeekData.flatMap(({ ViewMode, Months }) =>
            Months.flatMap(({ Month, Weeks }) =>
                Weeks.map(({ Week, Allocation, Ordered, PreliminaryOrdered, Excluded, DifferenceAllocatedOrdered }) => ({
                    Header: ViewMode,
                    Year: chosenYear,
                    Month: Month,
                    Week: Week,
                    AllocatedVolume: Allocation,
                    ActualOrderVolume: Ordered,
                    PreliminaryVolume: PreliminaryOrdered,
                    ExcludedVolume: Excluded,
                    Diff: DifferenceAllocatedOrdered
                }))
            )
        );
    }

    getDetailsHeader() {
        return (
            <div>
                <div>
                    <legend className="allocationLegend"><Convert.TextTo value_metric={"Details (t)"} value_imperial={"Details (tn)"}/></legend>
                    <Row className="detailsModes">
                        <Col sm={12} className="smaller-inputs">
                            <div className="detailsFont">View mode:</div>
                            <Row>
                                <Col md={2} sm={12}>{this.getViewModeBoxes(0)}</Col>
                                <Col md={2} sm={12}>{this.getViewModeBoxes(1)}</Col>
                                <Col md={2} sm={12}>{this.getViewModeBoxes(2)}</Col>
                                <Col md={2} sm={12}>{this.getViewModeBoxes(3)}</Col>
                                <Button bsStyle="primary" onClick={this.exportToExcel} disabled={this.state.data.DetailsView && this.state.data.DetailsView.length < 1}>Excel</Button>   
                                
                            </Row>
                        </Col>

                        <Col sm={12} className="smaller-inputs ml-auto">
                            <div className="detailsFont ml-auto">Sort order:</div>
                            <Select searchable={true}
                                styles={this.state.dropdownStyleMedium}
                                className="basic-select-70"
                                isClearable={true}
                                options={this.state.viewModesSortOrder}
                                menuContainerStyle={{ zIndex: 5 }}
                                value={this.state.selectedViewModesSortOrder}
                                onChange={evt => {
                                    this.state.selectedViewModesSortOrder = evt === null ? '' : evt;
                                    this.state.changedParams = true;
                                    this.setState({});
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

    // TODO: Fixa så det även rensar föregående val, och inte går att lägga två samma modes
    getViewModeBoxes(id) {
        if (this.state.viewModeBoxes.length < 4) {
            this.state.viewModeBoxes.push("");
        }
        return (
            <Select searchable={true}
                styles={this.state.dropdownStyleMedium}
                className="basic-select-70"
                isClearable={true}
                options={this.state.viewModes.filter(x => !this.state.viewModeBoxes.includes(x))}
                menuContainerStyle={{ zIndex: 5 }}
                value={this.state.viewModeBoxes[id]}
                onChange={evt => {
                    this.state.viewModeBoxes[id] = evt === null ? '' : evt;
                    this.state.changedParams = true;
                    this.setState({});
                }}
            />
        );
    }

    render() {
        if (this.state.isLoading) {
            return (
                <NPPanel>
                    <div>
                        {this.getAllocationSearch()}
                        <LoadingSpinner isLoading={true} />
                    </div>
                </NPPanel>
            );
        }
        else {
            return (
                <div>
                    <div className="margin-top-10">
                        <NPPanel>
                            {this.getAllocationSearch()}
                            {this.state.data.TotalsWeekView && this.state.data.TotalsWeekView.Months && this.state.data.TotalsWeekView.Months.length > 0 &&
                                <Row>
                                    <Col sm={8} style={{ marginTop: '7px' }}>
                                        <AllocationWeekTotals apiToken = {this.props.apiToken} data = {this.state.data.TotalsWeekView} userType = {this.state.userType} />
                                    </Col>
                                    <Col sm={4}>
                                        {hasGrant(Grants.TYPES.CustomerProfile_EditCustomerAllocation) && this.state.userType === "1" &&
                                            <EditedAllocationWarnings apiToken={this.props.apiToken} editedAllocations={this.state.editedAllocations} warningAllocations={this.state.warningAllocations} onWarningAllocationsChange={this.handleWarningAllocationsChange} setVerifyingAllocationCount={this.setVerifyingAllocationCount} onEditedAllocationsChange={this.handleEditedAllocationsChange} editMode={this.state.editMode} searchedYear={this.state.searchedYear} areaSalesDirectors={this.state.availableFilters.AreaSalesDirectors} searchObject={this.state.searchObject}/>
                                        }
                                    </Col>
                                </Row>
                            }
                        </NPPanel>
                        {hasGrant(Grants.TYPES.CustomerProfile_EditCustomerAllocation) &&
                            <NPPanel>
                                <AllocationGroups apiToken = {this.props.apiToken} data={this.state.data.AllocationLeaves} editedAllocations={this.state.editedAllocations} onEditedAllocationsChange={this.handleEditedAllocationsChange} warningAllocations={this.state.warningAllocations} areaSalesDirectors={this.state.availableFilters.AreaSalesDirectors} customers={this.state.availableFilters.Customers} verifyingAllocationCount={this.state.verifyingAllocationCount} legalEntity={this.state.legalEntity} selectedGroups={this.state.selectedGroups} onSelectedGroupsChange={this.handleSelectedGroupsChange} onEditModeChange={this.handleEditModeChange} editMode={this.state.editMode}/>
                            </NPPanel>
                        }
                        <NPPanel>
                            {this.getDetailsHeader()}
                            {this.state.data.DetailsView && this.state.data.DetailsView.length > 0 &&
                                <AllocationDetails apiToken = {this.props.apiToken} data = {this.state.data.DetailsView} userType = {this.state.userType} selectedYear={this.state.selectedYear.value}/>
                            }
                        </NPPanel>
                        {this.state.data.OnlyOrders && this.state.data.OnlyOrders.length > 0 &&
                            <NPPanel>
                                <legend className="allocationLegend"><Convert.TextTo value_metric={"Customer orders without allocations (t)"} value_imperial={"Customer orders without allocations (tn)"}/></legend>
                                <AllocationOnlyOrders apiToken = {this.props.apiToken} data = {this.state.data.OnlyOrders} userType = {this.state.userType} />
                            </NPPanel>
                        }
                    </div>
                </div>

            );
        }
    }
}

export default CustomerProfile;